import { A as e, a as o, C as t } from "./constants-DV0QHdfI.js";
const a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  APP_METADATA: e,
  AppId: o,
  COLLECTOR_APP_IDS: t
}, Symbol.toStringTag, { value: "Module" }));
export {
  a as i
};
